export const servicesData = [
    {
        title: 'servicesData.s1Title',
        description: 'servicesData.s1Desc',
        bulletPoints: [
            'servicesData.s1b1',
            'servicesData.s1b2',
            'servicesData.s1b3'
        ],
        icon: 'RefreshCw'
    },
    {
        title: 'servicesData.s2Title',
        description: 'servicesData.s2Desc',
        bulletPoints: [
            'servicesData.s2b1',
            'servicesData.s2b2',
            'servicesData.s2b3'
        ],
        icon: 'Flame'
    },
    {
        title: 'servicesData.s3Title',
        description: 'servicesData.s3Desc',
        bulletPoints: [
            'servicesData.s3b1',
            'servicesData.s3b2',
            'servicesData.s3b3'
        ],
        icon: 'Truck'
    },
    {
        title: 'servicesData.s4Title',
        description: 'servicesData.s4Desc',
        bulletPoints: [
            'servicesData.s4b1',
            'servicesData.s4b2',
            'servicesData.s4b3'
        ],
        icon: 'Factory'
    }
];

export const aboutUsData = {
    manifesto: 'about.manifesto',
    mission: 'aboutData.mission',
    vision: 'aboutData.vision',
    pillars: [
        {
            title: 'aboutData.pillar1Title',
            description: 'aboutData.pillar1Desc'
        },
        {
            title: 'aboutData.pillar2Title',
            description: 'aboutData.pillar2Desc'
        },
        {
            title: 'aboutData.pillar3Title',
            description: 'aboutData.pillar3Desc'
        },
        {
            title: 'aboutData.pillar4Title',
            description: 'aboutData.pillar4Desc'
        }
    ]
};

export const testimonialsData = [
    {
        quote: "Laz Metals logró despejar más de 500 toneladas de pasivos inactivos en nuestros patios en tiempo récord, sin paralizar nuestras operaciones diarias. Eficiencia pura.",
        author: "Director de Operaciones",
        company: "Complejo Industrial Regional"
    },
    {
        quote: "La transparencia en la romana y el pronto pago son incomparables. Desde que tercerizamos nuestro suministro de chatarra con ellos, los hornos no se han detenido.",
        author: "Jefe de Compras",
        company: "Fundición Metalúrgica Continental"
    },
    {
        quote: "Tienen el músculo logístico que promete. Llegaron con los roqueros y grúas pitman, y en dos días limpiaron lo que otras empresas no pudieron gestionar en meses.",
        author: "Gerente de Planta",
        company: "Zona Industrial Norte"
    }
];
